module.exports = __webpack_public_path__ + "static/media/image8.c3af70aa.JPG";